import React, { useState } from 'react';
import { Table, Button, message, Modal, Drawer } from 'antd';
import { FaPlus, FaEye, FaEdit } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri'
import { allPaths, translations } from '../../utils/constants';
import { ArrowDownToLine, Building2, Edit, EyeIcon, Search } from 'lucide-react';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import CustomModal from '../CustomModal/CustomModal';
import AddLedScreen from './AddLedScreen';
import PreviewLed from './PreviewLed';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchBusLed, verifyToken } from '../../utils/helpers';
import { setBusLedData, setTotalBusLed, setBusLedAllData, setBusLedPage, setBusLedPageSize } from '../../Redux/actions/busLedAction';
import { Tooltip, Popconfirm } from "antd";
import { Eye, Edit2, Trash2 } from "lucide-react";
import { GET, POST } from '../../utils/apis';
import { secureApi } from '../../Config/api';
import { setEditPanel } from '../../Redux/actions/panelAction';
import Panel from '../../Screens/Panel/panel';
import SearchPanel from '../SearchPanel/SearchPanel';
import axios from 'axios';
import DeleteModal from '../DeleteModal/DeleteModal';

const LedScreen = ({ language }) => {
    // Dummy data for the 
    const dispatch = useDispatch()
    const history = useHistory()
    const allBusLedFromRedux = useSelector((state) => state?.busLedReducer?.busLeds)
    const totalBusLed = useSelector((state) => state?.busLedReducer?.totalBusLed)
    const currentPage = useSelector(state => state.busLedReducer.currentPage)
    const pageSize = useSelector(state => state.busLedReducer.pageSize)
    const user = useSelector(state => state?.authReducer?.user)
    const organizationFromRedux = useSelector((state) => state.organizationReducer?.allOrganizations)
    const panelCount = useSelector((state) => state.panelReducer?.panelCount)
    const [searchModal, setSearchModal] = useState(false)
    const [selectedClients, setSelectedClients] = useState([])
    const [pdfLoading, setPdfLoading] = useState(false)
    const [deletingId, setDeletingId] = useState(null);
    const [editData, setEdtData] = useState(null);
    let authUser = user
    const userId = user?.id
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false)
    const [showPreview, setShowPreview] = useState(null)
    const [searchQuery, setSearchQuery] = useState('')
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);

    useEffect(() => {
        fetchBusLed({ setBusLedData, setTotalBusLed, dispatch, setBusLedAllData, user, currentPage, pageSize, setLoading, searchQuery, selectedClients });
    }, [currentPage, pageSize, searchQuery, selectedClients])

    // Open Modal
    const showModal = () => {
        setIsModalVisible(true);
    };
    // console.log(selectedClients, 'selectedClients')
    // Close Modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setEdtData(null)
    };

    const handleClosePreview = () => setShowPreview(null);

    const columns = [
        {
            title: translations[language]?.client,
            dataIndex: 'client',
            key: 'client',
            render: (value) => (value !== null && value !== undefined && value !== '') ? <span className='vl-name-text capitalized-name'>{value}</span> : <span className='vl-muted'>-</span>,
        },
        {
            title: translations[language]?.device || 'Device',
            key: 'serial_number',
            render: (value) => (value?.serial_number || value?.device_id)
                ? <span className='vl-plate'>{value?.serial_number || value?.device_id}</span>
                : <span className='vl-muted'>-</span>,
        },
        {
            title: translations[language]?.brand || 'Brand',
            dataIndex: 'brand',
            key: 'brand',
            render: (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : <span className='vl-muted'>-</span>,
        },
        {
            title: translations[language]?.direction || 'Direction',
            dataIndex: 'direction_code',
            key: 'direction_code',
            align: 'center',
            render: (value) => value ? <span className='vl-count-chip'>{value}</span> : <span className='vl-muted'>-</span>,
        },
        {
            title: translations[language]?.line || 'Line',
            dataIndex: 'line_code',
            key: 'line_code',
            render: (value) => (value !== null && value !== undefined) ? <span className='vl-plate'>{value}</span> : <span className='vl-muted'>-</span>,
        },
        {
            title: translations[language]?.front || 'Front',
            dataIndex: 'front_view',
            key: 'front_view',
            render: (value) => (
                <Tooltip title={translations[language]?.front || 'Front'}>
                    <button type='button' className='vl-action-btn vl-action-view' onClick={() => setShowPreview(value)}>
                        <Eye size={14} />
                    </button>
                </Tooltip>
            ),
        },
        {
            title: translations[language]?.rear || 'Rear',
            dataIndex: 'rear_view',
            key: 'rear_view',
            render: (value) => (
                <Tooltip title={translations[language]?.rear || 'Rear'}>
                    <button type='button' className='vl-action-btn vl-action-view' onClick={() => setShowPreview(value)}>
                        <Eye size={14} />
                    </button>
                </Tooltip>
            ),
        },
        {
            title: translations[language]?.side || 'Side',
            dataIndex: 'side_view',
            key: 'side_view',
            render: (value) => (
                <Tooltip title={translations[language]?.side || 'Side'}>
                    <button type='button' className='vl-action-btn vl-action-view' onClick={() => setShowPreview(value)}>
                        <Eye size={14} />
                    </button>
                </Tooltip>
            ),
        },
        {
            title: translations[language]?.action || 'Action',
            key: 'action',
            render: (_, record) => (
                <div className='vl-actions'>
                    <Tooltip title={translations[language]?.edit || 'Edit'}>
                        <button type='button' className='vl-action-btn vl-action-edit' onClick={() => handleEdit(record)}>
                            <Edit2 size={14} />
                        </button>
                    </Tooltip>

                    <Tooltip title={translations[language]?.delete || "Delete"}>
                        <button type='button' className='vl-action-btn vl-action-delete' onClick={() => { setSelectedDeleteRecord(record); setDeleteModal(true) }}>
                            <Trash2 size={15} />
                        </button>
                    </Tooltip>
                </div>
            ),
        },
    ];

    const expandedRowRender = (record) => {
        const frontView = record.front_view || {};
        const rearView = record.rear_view || {};
        const sideView = record.side_view || {};

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.view || 'View'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.panelRole || 'panel_role'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.panelModel || 'panel_model'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.text || 'text'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.effect || 'effect'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.speed || 'speed'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.brightness || 'brightness'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.font || 'font'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.mode || 'mode'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>{translations[language]?.margin || 'margin'}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontWeight: 'bold', paddingLeft: 10 }}>{translations[language]?.front || 'Front'}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.panel_role}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.model}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.text}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.effect}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.speed}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.brightness}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.font}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.mode}</td>
                        <td style={{ paddingLeft: 10 }}>{frontView.margin}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 'bold', paddingLeft: 10 }}>{translations[language]?.rear || 'Rear'}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.panel_role}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.model}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.text}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.effect}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.speed}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.brightness}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.font}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.mode}</td>
                        <td style={{ paddingLeft: 10 }}>{rearView.margin}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 'bold', paddingLeft: 10 }}>{translations[language]?.side || 'Side'}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.panel_role}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.model}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.text}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.effect}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.speed}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.brightness}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.font}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.mode}</td>
                        <td style={{ paddingLeft: 10 }}>{sideView.margin}</td>
                    </tr>
                </tbody>
            </table>
        );
    };

    const handleEdit = (record) => {
        dispatch(setEditPanel(record));
        setIsModalVisible(true);
    };

    const handleDeleteCancel = () => {
        setDeleteModal(false);
        setSelectedDeleteRecord(null);
    };

    const handleDelete = async () => {
        try {
            setDeletingId(selectedDeleteRecord?.id);
            const payload = {
                id: selectedDeleteRecord.id, // 👈 REQUIRED by backend
            };

            const res = await secureApi.post(POST.DELETE_BUS_LED, payload);

            if (res?.success) {
                message.success(translations[language]?.busLedDeletedSuccessfully || "Bus LED deleted successfully");
                setDeleteModal(false)
                // 🔁 Refresh list
                fetchBusLed({ setBusLedData, setTotalBusLed, dispatch, setBusLedAllData, user, currentPage, pageSize, setLoading, searchQuery, selectedClients })
            } else {
                message.error(res?.error || res?.message || "Delete failed");
            }

        } catch (error) {
            console.error("Delete Bus LED error", error);
            message.error("Failed to delete Bus LED");
        } finally {
            setDeleteModal(false)
            setDeletingId(null);
        }
    };

    const handleSearch = (query) => {
        setSearchQuery(query)
    }
    const organizationOptions = organizationFromRedux.map((item) => ({
        client: item.client,
        value: item.id,
    }))

    const downloadPanelPDF = async () => {
        try {
            setPdfLoading(true)

            const params = { client_ids: selectedClients?.map(c => c.value), language }

            const res = await axios.get(GET?.DOWNLOAD_PANEL_PDF, { params })

            if (res?.data?.success && res?.data?.data) {
                const pdfUrl = res.data.data

                const link = document.createElement('a')
                link.href = pdfUrl
                link.download = `${language === 'it' ? 'Rapporto_Pannelli' : 'Panel_Report'}.pdf`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                message.success(
                    language === 'it'
                        ? 'Rapporto pannelli scaricato con successo'
                        : 'Panel report downloaded successfully'
                )
            } else {
                message.error(
                    res?.data?.message ||
                    (language === 'it'
                        ? 'Impossibile scaricare il rapporto'
                        : 'Failed to download panel report')
                )
            }
        } catch (error) {
            console.error('PDF download error:', error)
            message.error(translations[language]?.pdfDownloadFail)
        } finally {
            setPdfLoading(false)
        }
    }


    return (
        <div className='main-container'>
            {isModalVisible ?
                <Panel setIsModalVisible={setIsModalVisible} /> :
                <div className='main-inner-container'>
                    <div className='insider-container-buttons report-header-div'>
                        <h1 className="main-heading">{translations[language]?.ledPanel}</h1>
                    </div>
                    <div className={'search-main-div'}>
                        <div className='add-button-div'>
                            <button
                                type='primary'
                                className='add-button'
                                onClick={showModal}  // Show modal on button click
                            >
                                <FaPlus className='icons' />
                                {translations[language]?.addBusLed}
                            </button>
                        </div>
                        <div className='search-main-div'>
                            <div className="search-inner-div">
                                <Search className="search-icon" />
                                <input
                                    placeholder={translations[language]?.searchPanel}
                                    value={searchQuery}
                                    onChange={(e) => handleSearch(e.target.value)}
                                    className="search-input"
                                    type='search'
                                />
                                {searchQuery && (
                                    <span className="clear-icon" style={{ cursor: "pointer" }} onClick={() => handleSearch("")}>
                                        ✕
                                    </span>
                                )}
                            </div>
                            <div className='get-reports-container'>
                                <span type='primary'
                                    className={`organization ${searchModal ? 'open-organization' : 'close-organization'}`}
                                    onClick={() => setSearchModal(!searchModal)}
                                >
                                    <Building2 />
                                    {translations[language]?.client}
                                    {panelCount ?
                                        <div className="filter-count-badge">
                                            {panelCount}
                                        </div>
                                        : null
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='vd-card' style={{ marginTop: 20 }}>
                        <div className='vd-card-header'>
                            <div className='vl-list-title'>
                                <h2 className='vd-card-title'>{translations[language]?.panelList}</h2>
                                <span className='vl-total-chip'>{translations[language]?.totalRecord}: <strong>{totalBusLed || 0}</strong></span>
                            </div>
                            <button
                                type='primary'
                                className='add-button'
                                onClick={downloadPanelPDF}
                                loading={pdfLoading}
                            >
                                {translations[language]?.getPDF}
                                <ArrowDownToLine style={{ height: '18px' }} className='icons' />
                            </button>
                        </div>
                        <div className='vd-card-body'>
                            <Table
                                className='vl-table'
                                dataSource={allBusLedFromRedux || []}
                                columns={columns}
                                rowKey="id"
                                expandedRowRender={expandedRowRender}
                                scroll={{ x: 'max-content' }}
                                loading={loading}
                                pagination={{
                                    current: currentPage,
                                    pageSize: pageSize,
                                    total: totalBusLed,
                                    showSizeChanger: true,
                                    onChange: (page, size) => {
                                        dispatch(setBusLedPage(page));
                                        dispatch(setBusLedPageSize(size));
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>}

            <DeleteModal
                title={translations[language]?.deleteBusLed}
                bodyText={
                    <>
                        {translations[language]?.areYouSureYouWantToDltThisBusLed}
                    </>
                }
                isOpen={deleteModal}
                onCancel={handleDeleteCancel}
                onDelete={handleDelete}
                language={language}
            />

            {showPreview && (
                <CustomModal
                    isVisible={showPreview ? true : false}
                    onClose={handleClosePreview}
                    title={translations[language]?.preview}
                    onAction={() => { }}
                >
                    <PreviewLed data={showPreview} language={language} />
                </CustomModal>
            )}
            <div className={`search-organization-main-div ${searchModal ? 'open' : ''}`}>
                <SearchPanel
                    selectedClients={selectedClients}
                    handleClientChange={clients => setSelectedClients(clients)}
                    clients={organizationOptions}
                    setSearchModal={setSearchModal}
                    searchModal={searchModal}
                    language={language}
                />
            </div>

        </div >
    );
};

export default LedScreen
